import React from "react";
import FinanicialStatementPage from "../../../../../entities/DashboardPage/AccountingModule/Reports/FinanicialStatement";
// import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
// import AuthService from "../../../../../api/AuthService";
// import AuthService from "../../../api/AuthService";
// eslint-disable-next-line import/default
// import LoaderHelper from "../../../utils/Loader/LoaderHelper";

const FinanicialStatement = () => {

  return (
    
    <FinanicialStatementPage/>
  )


}

export default FinanicialStatement;
